import React from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, transition } from 'theme';

import { Button } from './Button';

export const DotNavigationButton = styled(({ goToPage, index, className }) => {
  const clickHandler = () => {
    goToPage(index);
  };

  const title = `${getText('Go to page')} ${index + 1}`;
  return (
    <Button
      onClick={clickHandler}
      className={className}
      aria-label={title}
      title={title}
    >
      <Box pb="100%" />
    </Button>
  );
})`
  width: 12px;
  padding: 0;
  margin: 0 4px;
  background: white;
  border: 0;
  appearance: none;
  border-radius: 50%;
  box-shadow: 0 0 0 1px ${colors.waterBlue} inset;
  transition: all ${transition};
  ${({ isActive }) =>
    isActive &&
    `
    background: ${colors.waterBlue};
  `}
`;
